import React, { useContext, useState } from 'react';
import { Tabs } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import DeviceExport from '@totem/components/devices/devicesContainer/DeviceExport';
import DevicesContainer, {
  containerConfiguration,
} from '@totem/components/devices/devicesContainer/DevicesContainer';
import DeviceSearch from '@totem/components/devices/devicesContainer/DeviceSearch';
import GatewayDeviceOrgTable from '@totem/components/services/remoteAccess/roleUsers/rootRole/GatewayDeviceOrgTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import {
  DEVICES_CROSS_ORG_PAGINATION_ENDPOINT,
  GATEWAY_CROSS_ORG_PAGINATION_ENDPOINT,
} from '@totem/utilities/endpoints';

const styles = {
  totals: {
    fontSize: '16px',
    marginRight: '20px',
  },
  tabContainer: {
    paddingRight: '2rem',
    paddingLeft: '2rem',
  },
};

const CrossOrgRemoteAccessGatewaysPage = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <IBCard isCovered>
        <InputContainer
          filterConfig={containerConfiguration}
          useUrlParams
          defaultSort={{
            field: 'device.displayName',
            direction: 'ascend',
          }}
          componentKey={'dashboard.crossOrgRemoteAccessGateways'}
        >
          <DevicesContainer
            deviceEndPoint={GATEWAY_CROSS_ORG_PAGINATION_ENDPOINT}
            deviceFiltersEndPoint={`${DEVICES_CROSS_ORG_PAGINATION_ENDPOINT}/filters`}
            onRecordTotalChanged={setTotalRecords}
          >
            <IBTabs
              defaultActiveKey="Report"
              tabBarExtraContent={
                <span>
                  <b style={styles.totals}>{totalRecords} Gateways</b>
                  {permissions.systemAdministrator.hasPermissions(
                    userProfile,
                  ) && (
                    <IBTooltip
                      content={permissions.systemAdministrator.tooltip}
                    >
                      <DeviceExport
                        deviceExportEndPoint={
                          GATEWAY_CROSS_ORG_PAGINATION_ENDPOINT
                        }
                      />
                    </IBTooltip>
                  )}
                </span>
              }
              style={styles.tabContainer}
            >
              <Tabs.TabPane tab={'Gateways'} key="details">
                <DeviceSearch />
                <br />
                <GatewayDeviceOrgTable />
              </Tabs.TabPane>
            </IBTabs>
          </DevicesContainer>
        </InputContainer>
      </IBCard>
    </ContentLayout>
  );
};

export default CrossOrgRemoteAccessGatewaysPage;
